<template>
  <div class="paperlist">
    <van-nav-bar
      :title="'我的试卷'"
      left-arrow
      fixed
      @click-left="onClickLeft"
    />
    <div id="canvasPdf"  ></div>
  </div>
</template>
<script>
  import Pdfh5 from "pdfh5";
  import "pdfh5/css/pdfh5.css";
  export default {
    data() {
      return {
        pdfh5: null,
        formview:{
          filetype:null,
          typeid:null,
          filename:null,
          fileurl:null,
        }
      };
    },
    mounted() {
      this.formview.typeid = this.$route.params.paperId;
      this.formview.filetype = "paper";
      this.formview.filename = "";
      this.formview.fileurl = "";
      let data = {params:this.formview}
      let zhat= this;
      this.$ajax.get("/papersys/paper/filelist",data).then(response => {
        for(var i = 0;i < response.rows.length;i++)
        {
          zhat.formview.filename = response.rows[i].filename;
          zhat.formview.fileurl = response.rows[i].fileurl;
          //实例化
          this.pdfh5 = new Pdfh5("#canvasPdf", {
            pdfurl:  zhat.$global.paperfileapi+response.rows[i].fileurl,//这里就是pdf的路径，可以是本地的，也可以是服务器上的（https://eyepro.com/php_sqlsrv.pdf）
            zoomEnable: true   //控制是否支持缩放的属性，默认为true
          });
          //监听完成事件
          this.pdfh5.on("complete", function (status, msg, time) {
            console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
          })
        }
      });
    },
    methods:{
      onClickLeft() {
        this.$router.push('/mypaper')
      },
    }
  }
</script>
<style lang="scss" scoped>
  @import "pdfh5/css/pdfh5.css";
  *{
    padding: 0;
    margin: 0;
  }
  html,body,#app {
    width: 100%;
    height: 100%;
  }
  .paperlist{
    width: 100%;
    height: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/teacherpage/mypaperfile.vue